import { logEventAnalyticsUtil } from '../../../analytics/utils'
import setReduxAction from '../../../redux/actions/set'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import { updateWorkoutSectionStartWorkoutAction } from '../update-workout-section'
import { START_WORKOUT_ACTION, START_WORKOUT_ANALYTICS_EVENT, START_WORKOUT_PATH } from '../../constants'
import getCurrentSetWorkoutSelector from '../../selectors/get-current-set'
import getCurrentWorkoutExerciseIndexStartWorkoutSelect from '../../selectors/get-current-workout-exercise-index'
import getCurrentWorkoutSectionStartWorkoutSelect from '../../selectors/get-current-workout-section'
import getCurrentWorkoutSectionWorkoutExercisesStartWorkoutSelector
  from '../../selectors/get-current-workout-section-workout-exercises'
import getNextNonEmptyWorkoutSectionStartWorkoutSelect from '../../selectors/get-next-non-empty-workout-section'
import getNextSetSelect from '../../selectors/get-next-set'
import getNextWorkoutExerciseSelect from '../../selectors/get-next-workout-exercise'
import hasNextSetStartWorkoutSelect from '../../selectors/has-next-set'
import { WORKOUT_EXERCISES_PATH } from '../../../workout-exercise/redux/constants'
import getCurrentSetIndexWorkoutExerciseSelect from '../../../workout-exercise/redux/selectors/get-current-set-index'
import getRoundsWorkoutSectionUtil from '../../../workout-section/model/utils/get-rounds'
import { getRoundsDataWorkoutSectionUtil } from '../../../workout-section/model/utils/get-rounds-data'
import {
  hasCircuitNextExerciseWorkoutSectionUtil
} from '../../../workout-section/model/utils/has-circuit-next-exercise'
import { hasCircuitNextRoundWorkoutSectionUtil } from '../../../workout-section/model/utils/has-circuit-next-round'
import { hasCircuitRestWorkoutSectionUtil } from '../../../workout-section/model/utils/has-circuit-rest'
import isCircuitWorkoutSectionUtil from '../../../workout-section/model/utils/is-circuit'
import getCircuitCurrentRoundIndexWorkoutSectionSelect
  from '../../../workout-section/redux/selectors/get-circuit-current-round-index'
import getStartedWorkoutSelect from '../../../workout/redux/selectors/get-started'
import { logWorkoutAction } from '../../../workout/redux/actions'

function nextSetAction () {
  return (dispatch, getState) => {
    dispatch(setReduxAction({
      type: START_WORKOUT_ACTION.NEXT_SET,
      payload: {
        path: WORKOUT_EXERCISES_PATH.CURRENT_SET_INDEX,
        value: getCurrentSetIndexWorkoutExerciseSelect(getState()) + 1
      }
    }))
  }
}

function nextWorkoutExerciseAction (setIndex, workoutExerciseIndex) {
  return (dispatch, getState) => {
    const newWorkoutExerciseIndex = (
      workoutExerciseIndex != null
        ? workoutExerciseIndex
        : getCurrentWorkoutExerciseIndexStartWorkoutSelect(getState()) + 1
    )

    dispatch(setReduxAction({
      type: START_WORKOUT_ACTION.NEXT_WORKOUT_EXERCISE,
      payload: {
        paths: [
          START_WORKOUT_PATH.CURRENT_WORKOUT_EXERCISE_INDEX,
          WORKOUT_EXERCISES_PATH.CURRENT_SET_INDEX
        ],
        values: [
          newWorkoutExerciseIndex,
          setIndex ?? 0
        ]
      }
    }))
  }
}

function updateWorkoutExerciseAndSetIndexStartWorkoutAction (workoutExerciseIndex, setIndex) {
  return (dispatch) => {
    dispatch(setReduxAction({
      type: START_WORKOUT_ACTION.NEXT_ROUND,
      payload: {
        paths: [
          START_WORKOUT_PATH.CURRENT_WORKOUT_EXERCISE_INDEX,
          WORKOUT_EXERCISES_PATH.CURRENT_SET_INDEX
        ],
        values: [
          workoutExerciseIndex,
          setIndex
        ]
      }
    }))
  }
}

function nextWorkoutSectionAction () {
  return (dispatch, getState) => {
    const nextWorkoutSection = (
      getNextNonEmptyWorkoutSectionStartWorkoutSelect(getState())
    )
    dispatch(updateWorkoutSectionStartWorkoutAction(getIdReduxUtil(
      nextWorkoutSection)))
  }
}

function nextSetCircuit () {
  return (dispatch, getState) => {
    const workoutExercises = getCurrentWorkoutSectionWorkoutExercisesStartWorkoutSelector()(
      getState())
    const set = getCurrentSetWorkoutSelector(getState())
    const {
      rounds,
      roundIndex,
      setIndexInRound,
      round,
      roundSet
    } = getRoundsDataWorkoutSectionUtil(workoutExercises, set)

    // Same round: the next set is a rest, go to it
    if (hasCircuitRestWorkoutSectionUtil(set, roundSet)) {
      dispatch(nextSetAction())
      return
    }

    // Same round: if there is another workout exercise after, go to it
    if (hasCircuitNextExerciseWorkoutSectionUtil(round, setIndexInRound)) {
      const nextExerciseInRound = round[setIndexInRound + 1]
      dispatch(nextWorkoutExerciseAction(
        nextExerciseInRound.setIndex,
        nextExerciseInRound.workoutExerciseIndex
      ))
      return
    }

    // Next round: go to it
    if (hasCircuitNextRoundWorkoutSectionUtil(roundIndex, rounds)) {
      const rounds = getRoundsWorkoutSectionUtil(workoutExercises)
      const roundIndex = getCircuitCurrentRoundIndexWorkoutSectionSelect(
        getState())
      const nextRound = rounds[roundIndex + 1]
      const nextRoundSet = nextRound[0]
      dispatch(updateWorkoutExerciseAndSetIndexStartWorkoutAction(nextRoundSet.workoutExerciseOrder -
        1, nextRoundSet.setIndex))
      return
    }

    // Go to the next workout section
    dispatch(nextWorkoutSectionAction())
  }
}

function nextSetStartWorkoutAction () {
  return async (dispatch, getState) => {
    // If there is no set left, end the workout
    if (!hasNextSetStartWorkoutSelect(getState())) {
      await dispatch(logWorkoutAction())
      const startedWorkout = getStartedWorkoutSelect(getState())
      logEventAnalyticsUtil(
        START_WORKOUT_ANALYTICS_EVENT.FINISHED,
        startedWorkout
      )
      return
    }

    // If it's a circuit handle it differently
    const currentWorkoutSection = (
      getCurrentWorkoutSectionStartWorkoutSelect(getState())
    )
    if (isCircuitWorkoutSectionUtil(currentWorkoutSection)) {
      dispatch(nextSetCircuit(currentWorkoutSection))
      return
    }

    // Go to the next set
    if (getNextSetSelect(getState())) {
      dispatch(nextSetAction())
      return
    }

    // Go to the next workout exercise
    if (getNextWorkoutExerciseSelect(getState())) {
      dispatch(nextWorkoutExerciseAction())
      return
    }

    // Go to the next workout section
    dispatch(nextWorkoutSectionAction())
  }
}

export { updateWorkoutExerciseAndSetIndexStartWorkoutAction, nextSetStartWorkoutAction }
